import { TransferFormSearchRequest } from "../../../../../models/transferFormSearchPatterns";

export const initialState: TransferFormSearchRequest = {
  client: "",
  attachmentNamePatterns: [],
  subjectPatterns: [],
};